<template>
<div>
  <v-layout row justify-center><v-flex class="pt-4 px-2" xs12 md10>
    <v-layout row wrap justify-center>
      <v-flex class="pb-3 px-1" xs12 sm10 md6>
        <v-text-field
          label="Name"
          v-model.trim="newTask.name"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex class="pb-3 px-1" xs12 sm10 md6>
        <v-select
          label="Tags"
          v-model="newTask.tags"
          :items="getTags()"
          :multiple="newTask.type == 'Practice'"
          :chips="newTask.type == 'Practice'"
          hide-details
        ></v-select>
      </v-flex>
      <v-flex v-if="newTask.type == 'Practice'" class="pb-3 px-1" xs6 md3>
        <v-text-field
          label="# of Questions"
          v-model.trim="newTask.numOfQuestions"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex v-if="newTask.type == 'Practice'" class="pb-3 px-1" xs6 md3>
        <v-text-field
          label="Percent Easy (Optional)"
          v-model.trim="newTask.percentEasy"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex v-if="newTask.type == 'NCLEX'" class="pb-3 px-1" xs6 md3>
        <v-text-field
          label="Min Questions"
          v-model.trim="newTask.minQuestions"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex v-if="newTask.type == 'NCLEX'" class="pb-3 px-1" xs6 md3>
        <v-text-field
          label="Max Questions"
          v-model.trim="newTask.maxQuestions"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex class="pb-3 px-1" xs6 md3>
        <v-text-field
          label="Time Allowed (Mins)"
          v-model.trim="newTask.timeAllowed"
          :disabled="newTask.type == ''"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex class="pb-3 px-1" xs6 md3>
        <v-text-field
          label="Attempts"
          v-model.trim="newTask.attempts"
          :disabled="newTask.type == ''"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex class="pb-3 px-1" xs6 md3>
        <v-text-field
          label="Pass Grade"
          v-model.trim="newTask.passGrade"
          :disabled="newTask.type == ''"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex class="pb-3 text-xs-center" xs12>
        <v-btn
          @click.native="canCreate"
          color="success"
          :loading="updating"
          :disabled="updating"
          depressed
          large
        ><b>Update</b></v-btn>
        <v-btn
          @click.native="popup.type = 'Resetting', popup.show = true"
          color="error"
          flat
          large
        ><b>Reset</b></v-btn>
      </v-flex>
      <v-flex class="px-2 py-4" xs12 md10>
        <v-divider></v-divider>
      </v-flex>
      <v-flex class="px-2 pb-4 text-xs-center" xs12 md10>
        <v-btn @click.native="setupDeleteTask()" color="error" :disabled="deleting" :loading="deleting" large>Delete Task</v-btn>
      </v-flex>
    </v-layout>
  </v-flex></v-layout>

  <r-task-popup
    :popup="popup"
    :task-data="newTask"
    :deleting-data="toDelete"
  ></r-task-popup>
</div>
</template>

<script>
import TaskPopup from './TaskPopup.vue'
import {contentEvent} from '../../main'
export default {
  components: {
    rTaskPopup: TaskPopup
  },
  data: () => ({
    loading: false,
    updating: false,
    deleting: false,
    taskData: {},
    toDelete: {},
    allTags: [],
    newTask: {},
    popup: {
      show: false,
      type: ''
    }
  }),
  beforeMount () {
    contentEvent.$off()
    this.load()
    contentEvent.$on('updateTask', () => {
      this.updateTask()
    })
    contentEvent.$on('reset', () => {
      this.resetNewTest()
    })
    contentEvent.$on('delete', () => {
      this.deleteTask()
    })
  },
  methods: {
    load () {
      this.loading = true
      const contentData = this.$store.getters.contentByUrl(this.$route.params.contentUrl)
      let sectionData = {}
      for (let s of this.$store.getters.sectionByContent(contentData.key)) {
        if (s.url === this.$route.params.sectionUrl) sectionData = s
      }
      for (let t of this.$store.getters.taskBySection(sectionData.key)) {
        if (t.url === this.$route.params.taskUrl) this.taskData = t
      }
      this.resetNewTest()
      this.loading = false
    },
    resetNewTest () {
      this.newTask = {
        ...this.taskData,
        tags: this.taskData.type === 'Practice' ? [...this.taskData.tags] : this.taskData.tags,
        minQuestions: this.taskData.minQuestions ? this.taskData.minQuestions : '',
        maxQuestions: this.taskData.maxQuestions ? this.taskData.maxQuestions : '',
        numOfQuestions: this.taskData.numOfQuestions ? this.taskData.numOfQuestions : '',
        percentEasy: this.taskData.percentEasy ? this.taskData.percentEasy : '',
        timeAllowed: this.taskData.timeAllowed ? this.taskData.timeAllowed : '',
        attempts: this.taskData.attempts ? this.taskData.attempts : '',
        passGrade: this.taskData.passGrade ? this.taskData.passGrade : ''
      }
    },
    changed () {
      let name = this.newTask.name.toLowerCase() !== this.taskData.name.toLowerCase()
      let tags = false
      let timeAllowed = false
      let attempts = false
      let minQuestions = false
      let maxQuestions = false
      let numOfQuestions = false
      let percentEasy = false
      let passGrade = false
      if (this.newTask.timeAllowed !== '' && this.taskData.timeAllowed) {
        timeAllowed = this.newTask.timeAllowed !== this.taskData.timeAllowed
      } else if (this.newTask.timeAllowed === '' && typeof this.taskData.timeAllowed === 'undefined') {
        timeAllowed = false
      } else {
        timeAllowed = true
      }
      if (this.newTask.attempts !== '' && this.taskData.attempts) {
        attempts = this.newTask.attempts !== this.taskData.attempts
      } else if (this.newTask.attempts === '' && typeof this.taskData.attempts === 'undefined') {
        attempts = false
      } else {
        attempts = true
      }
      if (this.newTask.passGrade !== '' && this.taskData.passGrade) {
        passGrade = this.newTask.passGrade !== this.taskData.passGrade
      } else if (this.newTask.passGrade === '' && typeof this.taskData.passGrade === 'undefined') {
        passGrade = false
      } else {
        passGrade = true
      }
      if (this.newTask.type === 'NCLEX') {
        tags = this.newTask.tags !== this.taskData.tags
        minQuestions = this.newTask.minQuestions !== this.taskData.minQuestions
        maxQuestions = this.newTask.maxQuestions !== this.taskData.maxQuestions
      } else {
        tags = this.$store.getters.arrayEquals(this.newTask.tags, this.taskData.tags)
        numOfQuestions = this.newTask.numOfQuestions !== '' ? this.newTask.numOfQuestions !== this.taskData.numOfQuestions : false
        if (this.newTask.percentEasy !== '' && this.taskData.percentEasy) {
          percentEasy = this.newTask.percentEasy !== this.taskData.percentEasy
        } else if (this.newTask.percentEasy === '' && typeof this.taskData.percentEasy === 'undefined') {
          percentEasy = false
        } else {
          percentEasy = true
        }
      }
      return name || tags || timeAllowed || minQuestions || maxQuestions || numOfQuestions || percentEasy || attempts || passGrade
    },
    canCreate () {
      const appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.changed()) {
        const digit = this.$store.getters.reg.digit
        if (this.newTask.name === '') {
          appMsg.msg = 'Please enter a name for the section'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        }
        if (this.newTask.name.toLowerCase() === 'create') {
          appMsg.msg = 'Please use a different name; that name is reserved.'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        }
        if (this.newTask.name.toLowerCase() !== this.taskData.name.toLowerCase()) {
          const contentData = this.$store.getters.contentByUrl(this.$route.params.contentUrl)
          let sectionData = {}
          for (let s of this.$store.getters.sectionByContent(contentData.key)) {
            if (s.url === this.$route.params.sectionUrl) sectionData = s
          }
          let tasks = this.$store.getters.taskBySection(sectionData.key)
          for (let t of tasks) {
            if (this.newTask.name.toLowerCase() === t.name.toLowerCase()) {
              appMsg.msg = 'That task name already exists in this section'
              this.$store.dispatch('showAppMsg', appMsg)
              return
            }
          }
        }
        if (this.newTask.tags.length === 0) {
          appMsg.msg = 'Please choose at least one tag for this task'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        }
        if (this.newTask.timeAllowed === '') {
          appMsg.msg = 'Please enter only numbers greater than 0 for time allowed'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        } else if (!digit.test(this.newTask.timeAllowed)) {
          appMsg.msg = 'Please enter only numbers greater than 0 for time allowed'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        } else if (parseInt(this.newTask.timeAllowed) <= 0) {
          appMsg.msg = 'Please enter only numbers greater than 0 for time allowed'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        }
        if (this.newTask.attempts !== '') {
          if (!digit.test(this.newTask.attempts)) {
            appMsg.msg = 'Please enter only numbers greater than 0 for attempts'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          } else if (parseInt(this.newTask.attempts) <= 0) {
            appMsg.msg = 'Please enter only numbers greater than 0 for attempts'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          }
        }
        if (this.newTask.passGrade !== '') {
          if (!digit.test(this.newTask.passGrade)) {
            appMsg.msg = 'Please enter only numbers greater than 0 for pass grade'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          } else if (parseInt(this.newTask.passGrade) <= 0) {
            appMsg.msg = 'Please enter only numbers greater than 0 for pass grade'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          }
        }
        if (this.newTask.type === 'Practice') {
          if (this.newTask.numOfQuestions === '') {
            appMsg.msg = 'Please enter only numbers greater than 0 for number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          } else if (!digit.test(this.newTask.numOfQuestions)) {
            appMsg.msg = 'Please enter only numbers greater than 0 for number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          } else if (parseInt(this.newTask.numOfQuestions) <= 0) {
            appMsg.msg = 'Please enter only numbers greater than 0 for number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          }
          if (this.newTask.percentEasy !== '') {
            if (!digit.test(this.newTask.percentEasy)) {
              appMsg.msg = 'Please enter only numbers greater than 0 for percent easy'
              this.$store.dispatch('showAppMsg', appMsg)
              return
            } else if (parseInt(this.newTask.percentEasy) <= 0) {
              appMsg.msg = 'Please enter only numbers greater than 0 for percent easy'
              this.$store.dispatch('showAppMsg', appMsg)
              return
            }
          }
        } else {
          if (this.newTask.minQuestions === '') {
            appMsg.msg = 'Please enter only numbers greater than 0 for min number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          } else if (!digit.test(this.newTask.minQuestions)) {
            appMsg.msg = 'Please enter only numbers greater than 0 for min number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          } else if (parseInt(this.newTask.minQuestions) <= 0) {
            appMsg.msg = 'Please enter only numbers greater than 0 for min number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          }
          if (this.newTask.maxQuestions === '') {
            appMsg.msg = 'Please enter only numbers greater than 0 for max number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          } else if (!digit.test(this.newTask.maxQuestions)) {
            appMsg.msg = 'Please enter only numbers greater than 0 for max number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          } else if (parseInt(this.newTask.maxQuestions) <= 0) {
            appMsg.msg = 'Please enter only numbers greater than 0 for max number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          }
          if (parseInt(this.newTask.minQuestions) >= parseInt(this.newTask.maxQuestions)) {
            appMsg.msg = 'Minimun number of questions cannot be larger than maximum number of questions'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          }
        }
        if (this.newTask.type === 'NCLEX') contentEvent.$emit('nclexPopup')
        this.popup = {
          show: true,
          type: 'Updating Task'
        }
      } else {
        appMsg.msg = 'No changed detected'
        this.$store.dispatch('showAppMsg', appMsg)
      }
    },
    updateTask () {
      this.updating = true
      let nameChanged = this.newTask.name !== this.taskData.name
      if (nameChanged) {
        this.newTask.url = this.$store.getters.formatUrl(this.newTask.name)
      }
      this.formatTask()
      this.$store.dispatch('updateTask', this.newTask).then(() => {
        const appMsg = {
          type: 'success',
          msg: this.taskData.name + ' test updated'
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.updating = false
        this.$router.push('/content/' + this.$route.params.contentUrl + '/' + this.$route.params.sectionUrl)
      })
    },
    formatTask () {
      if (this.newTask.type === 'Practice') this.newTask.percentEasy = this.newTask.percentEasy === '' ? null : this.newTask.percentEasy
      this.newTask.timeAllowed = this.newTask.timeAllowed === '' ? null : this.newTask.timeAllowed
      this.newTask.attempts = this.newTask.attempts === '' ? null : this.newTask.attempts
    },
    getTags () {
      if (this.newTask.type === 'Practice') return this.$store.getters.tags
      else return ['RN', 'PN']
    },
    setupDeleteTask () {
      this.toDelete = {...this.taskData}
      this.popup = {
        show: true,
        type: 'Deleting Task'
      }
    },
    deleteTask () {
      this.deleting = true
      const taskName = this.toDelete.name
      this.$store.dispatch('deleteTask', this.toDelete).then(() => {
        const appMsg = {
          type: 'success',
          msg: taskName + ' has been deleted'
        }
        this.deleting = false
        this.$router.push('/content/' + this.$route.params.contentUrl + '/' + this.$route.params.sectionUrl)
        this.$store.dispatch('showAppMsg', appMsg)
      }).catch(err => {
        const appMsg = {
          type: 'error',
          msg: err.message
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.deleting = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/content/EditTest.vue